<template>
    <div>
        <b-button variant="success" @click.stop="abrirModal()"
            >Inserir Rateio</b-button
        >
        <rateio-requisicao-form
            titulo="Inserir Rateio"
            operacao="I"
            :requisicao="requisicao"
            :erros="erros"
            :mostrarModal="mostrarModal"
            @fecharModal="fecharModal()"
            @inserirRateio="$emit('inserirRateio', $event)"
        ></rateio-requisicao-form>
    </div>
</template>

<script>
import RateioRequisicaoForm from './RateioRequisicaoForm'

export default {
    props: {
        requisicao: {
            type: Object
        },

        erros: {
            type: Array,
            default: () => []
        }
    },

    components: {
        RateioRequisicaoForm
    },

    data() {
        return {
            mostrarModal: false
        }
    },

    methods: {
        fecharModal() {
            this.mostrarModal = false
        },

        abrirModal() {
            this.mostrarModal = true
        }
    },

    computed: {},

    created() {}
}
</script>
